<form (ngSubmit)="onSubmit()"
  #shiftForm="ngForm">

  <portal-modal class="shift-modal">
    <h4 title
      translate="shared.shift.title"
    class="modal-title"></h4>

    <div description
      class="modal-description">
      <div class="shift-option-box">

        <div translate="shared.shift.shiftByPeriodCount"></div>
        <input type="number"
          class="portal-input"
          portalInput
          [min]="0"
          [max]="maxPeriod"
          [step]="1"
          name="shiftPeriodCount"
          [(ngModel)]="shiftPeriodCount"
          (ngModelChange)="changePeriodByCount($event)">

        </div>
        <div class="shift-option-box">
          <div translate="shared.shift.shiftByDate"></div>
          @if (firstPlannablePeriod) {
            <portal-period-picker
              [selectedPeriod]="destinationPeriod"
              [minDate]="firstPlannablePeriod.startDate"
              [maxDate]="maxDate"
            (selectedPeriodChange)="setPeriod($event)" />
          }
        </div>
      </div>
      <div footer
        class="modal-footer ">
        <button class="portal-button"
          type="submit"
          translate="shared.shift.button"
        [disabled]="isShiftInvalid || !shiftForm.form.valid"></button>
        @if (isShiftInvalid) {
          <div
            class="error-box"
          translate="shared.shift.errorActual"></div>
        }
      </div>
    </portal-modal>

  </form>